import StoriesClient from './stories-client';

export async function generateStaticParams() {
  return [{ id: 'placeholder' }];
}

export default function StoriesPage({ params }: { params: { id: string } }) {
  return <StoriesClient eventId={params.id} />;
}
